import service from './axios';
export const getHomestayInfos = () => service.get('/manage/homestay-infos');
export const updateHomestayInfos = (d) => service.put('/manage/homestay-infos', d);
